/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Icsrm_Master11Inputs */

const en__field_enum_icsrm_master11 = /** @type {(inputs: _Field_Enum_Icsrm_Master11Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Master`)
};

const de__field_enum_icsrm_master11 = /** @type {(inputs: _Field_Enum_Icsrm_Master11Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Master`)
};

/**
* | output |
* | --- |
* | "Master" |
*
* @param {_Field_Enum_Icsrm_Master11Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_icsrm_master11 = /** @type {((inputs?: _Field_Enum_Icsrm_Master11Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Icsrm_Master11Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_icsrm_master11(inputs)
	return de__field_enum_icsrm_master11(inputs)
});
export { _field_enum_icsrm_master11 as "_field_enum_ICSRM_MASTER" }